import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Actions, ofType } from '@ngrx/effects';
import { Store, StoreModule } from '@ngrx/store';
import { zip } from 'rxjs';
import { environment } from '../environments/environment';
import { HeaderComponent } from './components/common/header/header.component';
import { AuthService } from './services/auth.service';
import { ThemeService } from './services/theme.service';
import { ReferenceDataActions } from './store/reference-data/reference-data.actions';
import { UserActions } from './store/user/user.actions';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent, StoreModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit {
  title = 'my-account-app';
  loading = true;
  constructor(private iconRegistry: MatIconRegistry, private sanitizer: DomSanitizer, private themeService: ThemeService, private store: Store, private actions$: Actions, private authService: AuthService) {
    this.registerIcons();
  }
  ngOnInit(): void {

    this.themeService.initializeTheme();

    if (!environment.production) {
      this.authService.setAccessToken(
        'eyJraWQiOiJKblwvdmhvSGhTZ29McjhGY1I1RG4xTGdTb3AzS3NHeVhhRkFYR3NiYjlxVT0iLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiI2MTNlY2Q3Mi1kN2VkLTRmZDctYWNiYy1kZmRlOGNiNzk2ZjMiLCJpc3MiOiJodHRwczpcL1wvY29nbml0by1pZHAuYXAtc291dGgtMS5hbWF6b25hd3MuY29tXC9hcC1zb3V0aC0xX2hxMjBsdEtFMiIsInZlcnNpb24iOjIsImNsaWVudF9pZCI6IjIxbTdibDZtZG0ydW9tdjA0MWM2cGVtNWs2Iiwib3JpZ2luX2p0aSI6IjQ2OTk2YmZkLTEyMTMtNDBhMi1iNzhlLTY3NjllNjIzZjQyZiIsInRva2VuX3VzZSI6ImFjY2VzcyIsInNjb3BlIjoiYXdzLmNvZ25pdG8uc2lnbmluLnVzZXIuYWRtaW4gb3BlbmlkIHByb2ZpbGUgZW1haWwiLCJhdXRoX3RpbWUiOjE3NjgxMTYwOTgsImV4cCI6MTc2ODIwMjQ5OCwiaWF0IjoxNzY4MTE2MDk4LCJqdGkiOiIwZTY1OGVmNy1hYTBjLTRiNTktYWQ0MS02YjM3OWVhZmZmYTAiLCJ1c2VybmFtZSI6IjRiY2NjNzJiLTNiZDctNDcwNC05NDUwLTg5YzNkYjVkNmY5NiJ9.qm4mEZ2hS3jeoa-_mcvib69SmnT42ttaSzDUFkerFPZxXGyrQg3wfDR5YC89btKDB-zztpgGMqTf2qjUASuWMO7zLr16-nEA2y-2vEr8VjEqM3ohpSJF_-fW2drA7qX4Rh0STm6yrNT0Ji5O5MVeop73wUjDcL5WPuzxirRJTAjGOcozzcnnh9Mj2ZBINHITuNPKLdcDfRO8dADBUR7iyhtLUq_Xhrd3TT36jMMyydRksvGKMs0sYsM80dl11ndSfXU9cZlZTo4zLknJGSIZv9-lOfeP4BMQqntUyPJYdB1xCnKliD84cHAiKkjpL9-8o3N57WDwTJy76Qky7BL0ew'
      );
    }

    this.store.dispatch(ReferenceDataActions.GET_COUNTRIES());
    this.store.dispatch(UserActions.GET_USER())


    zip(this.actions$.pipe(ofType(ReferenceDataActions.GET_COUNTRIES_SUCCESS)),
      this.actions$.pipe(ofType(UserActions.GET_USER_SUCCESS))
    ).subscribe(([a, b]) => {
      this.loading = false;
    });



  }

  registerIcons() {
    this.iconRegistry.addSvgIcon('ic_sbox_brackets', this.sanitizer.bypassSecurityTrustResourceUrl(environment.ic_sbox_brackets))
  }

}
